import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["start", "pastWarning"]
  static values = { warnPastStart: Boolean }

  connect() {
    this.check()
  }

  check() {
    const start = this.startTarget.value
    const today = new Date().toLocaleDateString("en-CA")

    this.toggle(this.pastWarningTargets[0], this.warnPastStartValue && start && start < today)
  }

  toggle(element, show) {
    element?.classList.toggle("tw-hidden", !show)
  }
}
